export default __webpack_public_path__ + "static/media/navbar-logo.d25c606a.svg";